var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-snackbar',{attrs:{"color":_vm.color,"timeout":_vm.timeout,"top":_vm.top,"min-height":"30px","min-width":"80vw"},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('div',{staticClass:"text-h4 text-center text-no-wrap"},[_vm._v(" "+_vm._s(_vm.text)+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }